<template>
  <div :class="[rootClass, `${rootClass}--color-${color}`]" v-click-outside="close">
    <i v-if="icon" :class="[`${rootClass}__icon`, `fa fa-${icon}`]"></i>
    <div class="dropdown-wrapper">
      <div
        class="dropdown-selected"
        @click="toggle"
        :class="{ 'is-placeholder': !selectedOption }"
      >
        <span>{{ selectedOption ? selectedOption.text : placeholder }}</span>
        <i class="fa fa-chevron-down dropdown-arrow"></i>
      </div>
      <div v-if="isOpen" class="dropdown-menu-custom">
        <div
          v-for="(option, index) in options"
          :key="`dropdown-option-${index}`"
          class="dropdown-item-custom"
          :class="{ 'is-selected': value === option.key, 'is-disabled': option.disabled }"
          @click="!option.disabled && select(option.key)"
        >
          {{ option.text }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomDropdown',
  directives: {
    'click-outside': {
      bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          if (!(el == event.target || el.contains(event.target))) {
            vnode.context[binding.expression](event);
          }
        };
        document.body.addEventListener('click', el.clickOutsideEvent);
      },
      unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
      },
    },
  },
  props: {
    id: {
      type: String,
      required: false
    },
    name: {
      type: String,
      required: true
    },
    icon: String,
    placeholder: String,
    color: {
      type: String,
      default: 'white'
    },
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      rootClass: 'custom-select',
      isOpen: false
    }
  },
  computed: {
    selectedOption() {
      return this.options.find(opt => opt.key === this.value);
    }
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    },
    close() {
      this.isOpen = false;
    },
    select(key) {
      this.$emit('input', { name: this.name, value: key });
      this.isOpen = false;
    }
  }
}
</script>

<style scoped>
.custom-select {
  display: flex;
  justify-content: flex-start;
  gap: 0.75rem;
  width: 100%;
  position: relative;
  height: 100%;
}

.custom-select__icon {
  display: flex;
  align-items: center;
}

.dropdown-wrapper {
  flex: 1;
  position: relative;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.dropdown-selected {
  padding: 0.25rem 0;
  border-bottom: 1px solid transparent;
  min-height: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  gap: 1rem;
  font-size: 0.875rem;
}

.dropdown-selected span {
  flex: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.dropdown-selected.is-placeholder {
  opacity: 0.7;
}

.dropdown-arrow {
  font-family: 'FontAwesome' !important;
  font-style: normal;
  font-weight: normal;
  font-size: 0.8rem;
  margin-left: auto;
  flex-shrink: 0;
  display: inline-block !important;
}

.dropdown-menu-custom {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: #333;
  border: 1px solid #444;
  border-radius: 4px;
  margin-top: 4px;
  z-index: 1000;
  max-height: 200px;
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0,0,0,0.5);
}

.dropdown-item-custom {
  padding: 0.75rem 1rem;
  color: white;
  transition: background-color 0.2s;
  border-bottom: none !important;
  text-decoration: none !important;
}

.dropdown-item-custom:hover {
  background-color: #444;
}

.dropdown-item-custom.is-selected {
  background-color: #555;
  font-weight: bold;
}

.dropdown-item-custom.is-disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* White Theme (Default for Search) */
.custom-select--color-white .dropdown-selected,
.custom-select--color-white .dropdown-arrow,
.custom-select--color-white .custom-select__icon {
  color: white !important;
}


/* Black Theme (For Reservation Form) */
.custom-select--color-black .dropdown-selected,
.custom-select--color-black .dropdown-arrow,
.custom-select--color-black .custom-select__icon {
  color: #555 !important;
  font-weight: 300;
  font-family: inherit;
  font-size: 0.875rem;
}

.custom-select--color-black .dropdown-arrow {
  font-family: 'FontAwesome' !important;
}

.custom-select--color-black .dropdown-selected {
  border-bottom: none;
}

.custom-select--color-black .dropdown-menu-custom {
  background-color: white;
  border: 1px solid #ddd;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.custom-select--color-black .dropdown-item-custom {
  color: #333;
}

.custom-select--color-black .dropdown-item-custom:hover {
  background-color: #f8f9fa;
}

.custom-select--color-black .dropdown-item-custom.is-selected {
  background-color: #e9ecef;
}

/* HomeSearch specific adjustments */
@media (min-width: 993px) {
  .dropdown-selected {
    padding: 0 1.25rem;
    border: none;
    border-radius: 0;
    background-color: transparent;
    font-size: 1rem;
    height: 100%;
  }
}
</style>
